import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { DialogService } from 'src/app/services/dialog.service';
import { CerereTypeService } from './cerere-type.service';

import { AddCerereTypeComponent } from './add-cerere-type/add-cerere-type.component';
import { EditCerereTypeComponent } from './edit-cerere-type/edit-cerere-type.component';
import { helper } from 'src/environments/helper';
import { Observable, Subject, finalize, map } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';

import { CommonService } from 'src/app/services/common.service';

import { NotificationService } from 'src/app/services/notification.service';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
    selector: 'app-request-types',
    templateUrl: './cerere-type.component.html',
    styleUrls: ['./cerere-type.component.scss'],
})
export class CerereTypeComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;
    token!: string;
    isLoading = false;

    showCard = false;
    activeValue: string = '-1';
    publicValue: string = '-1';

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    directiiActive$: any = [];

    dtLink =
        environment.interop.basePath +
        environment.interop.deps.nomenclatoare.cerereType.listDT;
    onSelectionChange(event: any): void {
        this.activeValue = event.target.value;
        this.publicValue = event.target.value;
    }
    resetForm() {
        this.activeValue = '-1';
        this.publicValue = '-1';

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private notificationService: NotificationService,
        private dialogService: DialogService,
        private requestTypesService: CerereTypeService,
        private commonService: CommonService,
        public permissionsService: PermissionsService
    ) { }

    ngOnInit(): void {
        this.loadDirectiiActive();
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.active = this.activeValue;
                dataTablesParameters.public = this.publicValue;
                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Nume',
                    data: 'name',
                    width: '400px',
                },
                {
                    title: 'Slug',
                    data: 'slug',
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: (row: any) => {
                        return `
                        <div class="d-flex align-center justify-content-left">
                            <button class="action-btn edit me-1">
                                <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
                            </button>
                            <button class="action-btn delete me-1">
                                <img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
                            </button>
                        </div>
                        `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;

                if (editIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'deps-module.settings.tip-cerere.update'
                        )
                    ) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'deps-module.settings.tip-cerere.delete'
                        )
                    ) {
                        deleteIcon.style.display = 'none';
                    }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.deleteCerere(id);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    deleteCerere(id: number) {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.delete,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: this.helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: this.helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.requestTypesService.deleteRequestType(id).subscribe(() => {
                    this.rerenderDT();
                    Swal.fire({
                        title: this.helper.swalTextConfig.headers.deleted,
                        text: 'Tip Cerere ștearsă cu succes.',
                        icon: 'success',
                        confirmButtonText: this.helper.swalTextConfig.buttonLabels.ok,
                    });
                });
            }
        });
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddCerereTypeComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Tip Cerere adaugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditCerereTypeComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Tip Cerere actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    loadDirectiiActive() {
        this.isLoading = true;
        this.directiiActive$ = this.commonService.getDirectiiActive().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    clearCache() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.cleanCache,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: this.helper.swalTextConfig.buttonLabels.confirm,
            cancelButtonText: this.helper.swalTextConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.requestTypesService.clearCache().subscribe(() => {
                    this.rerenderDT();
                    Swal.fire({
                        title: this.helper.swalTextConfig.headers.deleted,
                        text: this.helper.swalTextConfig.generalMessages.cleanCacheSuccess,
                        icon: 'success',
                        confirmButtonText: this.helper.swalTextConfig.buttonLabels.ok,
                    });
                });
            }
        });
    }
}
